import { COMPANY_TYPES, DIRECTION_TEXT, NETWORK_TEXT } from "interfaces";
import { IStores } from "stores";
import {
  formatWithDecimals,
  CURRENCY_TYPE,
  dateFormat,
  RUB_CURRENCY,
  EXPLORER_LINK_TYPE,
  getBlockchainExplorerLink,
  getCompanyType,
} from "utils";
import { TxButton } from "ui";

type Props = {
  bidCard: IStores["bidCard"];
  quoteSelectedData: IStores["quotes"]["quoteSelectedData"];
  user: IStores["user"];
  isExecuteModal: boolean;
  showAddressWallet: boolean;
};

export const getBidInfo = ({ bidCard, quoteSelectedData, user, isExecuteModal, showAddressWallet }: Props) => {
  const { isProvider } = user?.roles;

  const bidInfo = [
    {
      label: "Номер заявки",
      text: `№${bidCard.bid.hid}`,
    },
    bidCard.bid.contract.unk
      ? {
          label: "Договор УНК",
          text: bidCard.bid.contract.unk,
        }
      : undefined,

    {
      label: "Тип договора",
      text: DIRECTION_TEXT[bidCard.bid.contract.direction],
    },
  ];

  const contractCompanyInfo = [
    bidCard.bid.contract.companyName
      ? {
          label: "Организация",
          text: bidCard.bid.contract.companyName,
        }
      : undefined,
    bidCard.bid.contract.customerRegistrationNumber
      ? {
          label:
            getCompanyType(bidCard.bid.contract.customerRegistrationNumber) === COMPANY_TYPES.IP
              ? "ОГРНИП"
              : "ОГРН",
          text: bidCard.bid.contract.customerRegistrationNumber,
        }
      : undefined,
  ].filter((i) => !!i);

  const walletInfo = [
    isExecuteModal && showAddressWallet
      ? {
          label: "Кошелек получателя",
          text: (
            <TxButton
              text={bidCard.bid.destinationWallet ?? ""}
              href={getBlockchainExplorerLink(
                bidCard.bid.network,
                bidCard.bid.destinationWallet ?? "",
                EXPLORER_LINK_TYPE.address
              )}
              isWalletAddress
              showCopyBtn={false}
            />
          ),
        }
      : undefined,
    {
      label: "Сеть",
      text: bidCard.bid.network && NETWORK_TEXT[bidCard.bid.network],
    },
    {
      label: "Сумма ЦВ",
      text: `${formatWithDecimals(bidCard.bid.amount)} ${bidCard.bid.currency}`,
    },
    !isProvider && !isExecuteModal && bidCard.bid.amountRub
      ? {
          label: "Сумма в рублях",
          text: `${formatWithDecimals(bidCard.bid.amountRub)} ${RUB_CURRENCY.RUB}`,
        }
      : undefined,
    bidCard.bid.quote?.rate
      ? {
          label: `Курс`,
          text: `1 ${bidCard.bid.currency} = ${formatWithDecimals(bidCard.bid.quote?.rate)} ${CURRENCY_TYPE.RUB}`,
        }
      : undefined,
    quoteSelectedData?.rate
      ? {
          label: `Курс`,
          text: `1 ${bidCard.bid.currency} = ${formatWithDecimals(quoteSelectedData?.rate)} ${CURRENCY_TYPE.RUB}`,
        }
      : undefined,
  ];

  return { bidInfo, contractCompanyInfo, walletInfo };
};

export const getUserInfo = (user: IStores["user"]) => {
  return [
    {
      label: "ФИО Пользователя",
      text: `${user.userInfo?.surname} ${user.userInfo?.name} ${user.userInfo?.second_name}`,
    },
    {
      label: "Дата",
      text: dateFormat(new Date()),
    },
  ];
};
